export default function getPrevMerchantState() {
    return {
        data: {
            merchantItems: []
        }
    };
}



// WEBPACK FOOTER //
// ./src/MerchantItems/Reducer/getPrevMerchantItemsState.js